module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-orange-134c4681.svg";